(function(SCS, $) {
	'use strict';

	var arrayProto = Array.prototype;
	
	var isArray = Array.isArray || function(object) {
		return Object.prototype.toString.call(object) === '[object Array]';
	};

	var inArray = ('indexOf' in arrayProto && function inArray(item, array) {
		return arrayProto.indexOf.call(array, item);
	}) || $.inArray;

	var extend = ($ && $.extend) || function extend(base) {
		var extendWith = arrayProto.slice.call(arguments, extend.length);
		for(var i=0;i<extendWith.length;i+=1) {
			for(var name in extendWith[i]) {
				// jshint forin: false
				base[name] = extendWith[i][name];
			}
		}
		return base;
	};

	/**
	 * Flattens an object/array in to a single array where the nth item is the key path and the n+1th item is the value
	 */
	function flatten(object, result, prefix) {
		result = result || [];
		prefix = prefix || '';
		if(isArray(object)) {
			for(var i=0;i<object.length;i+=1) {
				flatten(object[i], result, prefix+'[]');
			}
		} else if(typeof(object) === 'object' && object !== null) {
			for(var k in object) {
				// jshint forin: false
				var p = prefix ? prefix+'['+k+']' : k;
				flatten(object[k], result, p);
			}
		} else {
			result.push(prefix, String(object));
		}
		return result;
	}

	function urlEncode(string) {
		return window.encodeURIComponent(string).replace(/%20/g, '+');
	}

	function param(object) {
		var items = flatten(object);
		var result = [];
		for(var i=0;i<items.length;i+=2) {
			result.push(urlEncode(items[i])+'='+urlEncode(items[i+1]));
		}
		return result.sort().join('&');
	}

	function parallel(operations, callback) {
		if(!operations.length) {
			return callback();
		}
		var pending = operations.length;
		function done() {
			pending -= 1;
			if(pending === 0) {
				callback();
			}
		}
		var apis = [];
		for(var i=0;i<operations.length;i+=1) {
			apis.push(operations[i](done));
		}
		return {
			abort: function() {
				for(var i=0;i<apis.length;i+=1) {
					if(apis[i]) {
						apis[i].abort();
					}
				}
			}
		};
	}

	var search = SCS.search = SCS.search || {};
	var util = search.util = search.util || {};

	if(window.QUnit) {
		// Visible for testing
		util.internals = util.internals || {};
		util.internals = {
			urlEncode: urlEncode
		};
	}


	util.isArray = isArray;
	util.inArray = inArray;
	util.extend = extend;
	util.param = param;
	util.parallel = parallel;

})(window.SCS = window.SCS || {}, 'Tc' in window ? window.Tc.$ : window.$);


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/processing/js/util/shims.js
// module id = 41
// module chunks = 0